var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackageDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1560_1210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3913 3.69687L8.32603 0.11696L8.32309 0.115491C8.0085 -0.0411342 7.63469 -0.0376342 7.32303 0.124866L4.29275 1.73312C4.26813 1.74355 4.24447 1.75621 4.22181 1.77077L0.5905 3.69802C0.22625 3.88874 0 4.26243 0 4.67371V11.3262C0 11.7375 0.22625 12.1112 0.5905 12.3019L7.32003 15.8735L7.32306 15.8751C7.482 15.958 7.65716 15.9995 7.83234 15.9995C8.00062 15.9995 8.16897 15.9612 8.32309 15.8845L15.3913 12.3031C15.7668 12.1153 16 11.7381 16 11.3181V4.68187C16 4.2619 15.7668 3.88462 15.3913 3.69687ZM7.75741 0.955272C7.80331 0.93171 7.85813 0.931241 7.90444 0.95396L14.5178 4.3049L11.944 5.5863L5.47837 2.16483L7.75741 0.955272ZM7.357 14.8322L1.02844 11.4733L1.02541 11.4717C0.971 11.4433 0.937156 11.3876 0.937156 11.3262V5.09658L7.357 8.44421V14.8322ZM7.83053 7.63421L1.446 4.30499L4.478 2.69583L10.9116 6.1003L7.83053 7.63421ZM15.0628 11.3181C15.0628 11.3808 15.0279 11.4371 14.9718 11.465L8.29419 14.8485V8.45024L11.3687 6.91955V8.5244C11.3687 8.78318 11.5786 8.99299 11.8373 8.99299C12.0961 8.99299 12.3059 8.78318 12.3059 8.5244V6.45296L15.0628 5.08046V11.3181Z",
    fill: "#3F4752"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1560_1210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageDark);
export default __webpack_public_path__ + "static/media/package_dark.36e0352148d2b148617a85e1968e558a.svg";
export { ForwardRef as ReactComponent };